import styled from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/core';

export const ResourceGridCellWrapper = styled.div`
    min-width: ${getSpacingToken('800')}px;
    display: flex;
    align-items: center;
    min-height: ${getToken('sizing500')}px;
`;
